import { Feather } from '@expo/vector-icons';
import { useNavigation } from '@react-navigation/native';
import React, { useContext, useEffect, useState } from 'react';
import { Text, TouchableOpacity, View } from "react-native";
import { SafeAreaView } from "react-native-safe-area-context";
import { RadioButton } from 'react-native-paper';
import styles from './styles';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { AppContext } from '../../Context/AppContext';

const Color = () => {
    const { goBack } = useNavigation();
    const { bgColor, setBgColor } = useContext(AppContext);

    async function saveColor(color: string) {
        await AsyncStorage.setItem('bgColor', color);
        setBgColor(color);
    }

    useEffect(() => {
        (async () => {
            const color = await AsyncStorage.getItem('bgColor');
            if (color) {
                setBgColor(color);
            }
        })();
    }, []);

    return (
        <SafeAreaView style={[
            styles.mainContainer,
            {
                backgroundColor:bgColor 
            }
        ]}>
            <View style={styles.header}>
                <TouchableOpacity
                    onPress={() => goBack()} 
                >
                    <Feather name="arrow-left" size={28} />
                </TouchableOpacity>
            </View>
            <View style={styles.contentContainer}>
                <Text style={styles.title}>
                    Selecione uma cor de fundo:
                </Text>
                <RadioButton.Group onValueChange={value => saveColor(value)} value={bgColor}>
                    <RadioButton.Item
                        value="#fff" 
                        label="Branco"
                    />
                    <RadioButton.Item
                        value="#d6cf89" 
                        label="Amarelo"
                    />
                </RadioButton.Group>
            </View>
        </SafeAreaView>
    );
};

export default Color;